"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from "next-intl";
import { useCallback } from "react";
import { safeKey } from "./i18n-keys";
import type { Locale } from "@/i18n/routing";
export type TValues = Record<string, string | number>;
export type TFn = (key: string, values?: TValues) => string;

/** The UI string for `key` (English display text) in the page's locale. */
export function useT() {
  const $ = _c(2);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = (key, values) => t(safeKey(key), values);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

/** The page's locale as the game code the API and asset paths use. */
export function useGameLocale() {
  return useLocale() as Locale;
}